import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import { buildFullName } from "./queue"
import dayjs from "dayjs"
export async function getJustificationsOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.JUSTIFICATIONS)

  data = await Promise.all(
    data.map(async (j) => {
      let patient = j.patient

      if (!patient || typeof patient !== "object") {
        patient = await getByIdOffline(STORES.PATIENTS, j.patientId)
      }

      return {
        ...j,
        patient,
        fullName: j.fullName || buildFullName(patient),
      }
    }),
  )

  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((j) => j.fullName?.toLowerCase().includes(search))
  }

  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
